/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { gql } from '@apollo/client';

const findRecentlyViewedRecsSF = (queryName = 'RecentlyViewedRecommendations') => (
    gql`query ${queryName}(
      $brand: String!,
      $environment: String!,
      $targeting: TargetingSF!
      $user: UserSF!
      $isHoldoutEligible: Boolean!
      $resolveIdentity: Boolean!
    ) {
      recentlyViewedRecs(
        brand: $brand,
        environment: $environment,
        targeting: $targeting,
        user: $user,
        isHoldoutEligible: $isHoldoutEligible
        resolveIdentity: $resolveIdentity
    ) {
      campaign
      products {
        partNumber
        name
        isPassportEligible
        image {
          name
          path
        }
        seo {
          url
        }
        skuPriceRange {
          retail {
            value
          }
          sale {
            value
          }
        }
        productSkus {
          partNumber
          name
        }
        productType,
        productDeliveryType,
      }
      productRecs {
        partNumber
        name
        isPassportEligible
        image {
          name
          path
        }
        seo {
          url
        }
        skuPriceRange {
          retail {
            value
          }
          sale {
            value
          }
        }
        productSkus {
          partNumber
          name
        }
        productType,
        productDeliveryType,
      }
      seedProduct {
        partNumber
        name
        image {
          name
          path
        }
        seo {
          url
        }
      }
      productsContent
      productRecsContent
      isHoldOut
    }
    }
  `
);

export default findRecentlyViewedRecsSF;
